"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenJsonArray = exports.flattenJson = void 0;
function flattenJson(data, parentKey, result) {
  if (parentKey === void 0) {
    parentKey = '';
  }
  if (result === void 0) {
    result = {};
  }
  var _loop_1 = function (key) {
    if (data.hasOwnProperty(key)) {
      var newKey_1 = parentKey ? "".concat(parentKey, ".").concat(key) : key;
      var value = data[key];
      if (Array.isArray(value)) {
        value.forEach(function (item, index) {
          if (item && typeof item === 'object') {
            flattenJson(item, "".concat(newKey_1, ".").concat(index + 1), result);
          } else {
            result["".concat(newKey_1, ".").concat(index + 1)] = item;
          }
        });
      } else if (value && typeof value === 'object') {
        flattenJson(value, newKey_1, result);
      } else {
        result[newKey_1] = value;
      }
    }
  };
  for (var key in data) {
    _loop_1(key);
  }
  return result;
}
exports.flattenJson = flattenJson;
function flattenJsonArray(dataArray) {
  return dataArray.map(function (item) {
    if (item && typeof item === 'object' && !Array.isArray(item)) {
      return flattenJson(item);
    }
    return item;
  });
}
exports.flattenJsonArray = flattenJsonArray;
// Example usage:
// const nestedJsonArray = [
//     {
//         a: {
//             b: [
//                 { c: 1 },
//                 { d: 2 }
//             ],
//             e: 3
//         },
//         f: 4
//     },
//     {
//         g: {
//             h: [5, 6]
//         },
//         i: 7
//     }
// ];
// const flatJsonArray = flattenJsonArray(nestedJsonArray);
// console.log(flatJsonArray);
// // Expected output:
// // [
// //     {
// //         "a.b[0].c": 1,
// //         "a.b[1].d": 2,
// //         "a.e": 3,
// //         "f": 4
// //     },
// //     {
// //         "g.h[0]": 5,
// //         "g.h[1]": 6,
// //         "i": 7
// //     }
// // ]